import React from 'react';
import PropTypes from 'prop-types';
import SectionMessage from '@atlaskit/section-message';

const getAppearance = (value) => {
  if (value === 'success') {
    return 'confirmation';
  }
  return value;
};

const TypeSectionMessage = props => (
  <div style={{ margin: '12px 0 0 0' }}>
    <SectionMessage
      {...props}
      appearance={getAppearance(props.appearance)}
      actions={[
        ...props.actions,
        {
          text: 'Close',
          onClick: props.onClose,
        },
      ]}
    >
      {props.children}
    </SectionMessage>
  </div>
);

TypeSectionMessage.propTypes = {
  appearance: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

TypeSectionMessage.defaultProps = {
  actions: [],
  appearance: 'info',
  children: '',
};

export default TypeSectionMessage;
